"use client"

import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Confetti from 'react-confetti'
import axios from 'axios'
import backendUrl from '../../apiConfig'

export default function SuccessPage() {
    const [username, setUsername] = useState('')
    const [linkTreeUrl, setLinkTreeUrl] = useState('')
    const [linktree, setLinktree] = useState('')
    const [showConfetti, setShowConfetti] = useState(true)
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    })

    const navigate = useNavigate()

    const fetchData = useCallback(() => {
        if (username) {
            axios
                .get(`${backendUrl}/retrieve/html/${username}`)
                .then((response) => {
                    setLinktree(response.data)
                    setLinkTreeUrl(`${backendUrl}/retrieve/html/${username}`)
                })
                .catch((error) => console.error('Error fetching server data:', error))
        }
    }, [username])

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = localStorage.getItem('jwtToken')
                const details = await axios.get(`${backendUrl}/user/getuser`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                setUsername(details.data.username)
            } catch (err) {
                console.error('Error fetching user details:', err)
            }
        }

        fetchUser()
    }, [])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }

        window.addEventListener('resize', handleResize)

        const timer = setTimeout(() => {
            setShowConfetti(false)
        }, 10000)

        return () => {
            window.removeEventListener('resize', handleResize)
            clearTimeout(timer)
        }
    }, [])

    const handleShare = async () => {
        try {
            if (navigator?.share) {
                await navigator.share({
                    title: 'My Linktree',
                    text: 'Check out my Linktree!',
                    url: `${linkTreeUrl}`,
                })
            } else {
                await navigator.clipboard.writeText(`${linkTreeUrl}`)
                alert('Link copied to clipboard!')
            }
        } catch (error) {
            console.error('Error sharing:', error)
        }
    }

    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12">
            <div className="fixed top-0 left-0 right-0 h-1 bg-gray-100">
                <div className="h-full bg-purple-500 w-screen" />
            </div>
            {showConfetti && (
                <Confetti
                    width={windowSize.width}
                    height={windowSize.height}
                    recycle={false}
                    numberOfPieces={200}
                />
            )}

            <div className="text-center max-w-[600px] mt-12 mx-auto">
                <h1 className="text-[42px] text-black font-black leading-tight mb-4">
                    Your Linktree is ready!
                </h1>
                <p className="text-gray-600 text-lg mb-2">
                    It's time to share it with the world
                </p>
                <p className="text-[#5C37B6] font-medium mb-12">{linkTreeUrl}</p>

                <div className="mb-12 w-full max-w-[380px] mx-auto">
                    <div className="relative w-full aspect-[9/16] rounded-[3rem] mx-auto overflow-hidden border-4 border-gray-100 shadow-[0_30px_70px_rgba(0,0,0,0.35)] shadow-2xl">
                        <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-white/10 to-transparent " />

                        <button className="absolute top-8 right-8 p-2 hover:bg-black/5 rounded-full z-50 text-black cursor-pointer transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="1" />
                                <circle cx="19" cy="12" r="1" />
                                <circle cx="5" cy="12" r="1" />
                            </svg>
                        </button>

                        {/* <div className="pt-16 px-6 text-center z-50">
                            <div className="w-20 h-20 bg-black rounded-full mx-auto mb-4 flex items-center justify-center">
                                <span className="text-white text-2xl font-medium">
                                    {username.charAt(0).toUpperCase()}
                                </span>
                            </div>
                            <p className="text-[#5C37B6] text-lg font-medium mb-8">
                                @{username}
                            </p>
                        </div> */}

                        <iframe
                            title="User Link Tree"
                            srcDoc={`
                                        <style>
                                            ::-webkit-scrollbar { display: none; }
                                            html {
                                                scrollbar-width: none;
                                                -ms-overflow-style: none;
                                            }
                                            body { margin: 0; padding-top: 140px; }
                                        </style>
                                        ${linktree}
                                    `}
                            className="w-full h-full absolute top-0 left-0"
                            style={{
                                overflow: 'auto',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                                background: 'transparent'
                            }}
                        />
                    </div>
                </div>

                <div className="fixed bottom-8 left-1/2 -translate-x-1/2 flex flex-row gap-4 w-[60%]">
                    <button
                        onClick={handleShare}
                        className="flex-1 bg-[#8B3DFF] hover:bg-[#7935E5] text-white font-medium py-3 px-6 rounded-full flex items-center justify-center gap-2 transition-colors text-sm"
                    >
                        Share your Linktree
                    </button>
                    <button
                        onClick={() => navigate('/admin')}
                        className="flex-1 bg-white hover:bg-gray-50 text-gray-900 font-medium py-3 px-6 rounded-full border border-gray-100 transition-colors text-sm shadow-sm"
                    >
                        Continue editing
                    </button>
                </div>
            </div>
        </div>
    )
}